/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  deleteData,
  fetchData,
  postData,
  putData,
} from "@jda/lui-portal-utilities";
import { createRequestObject, getAuthToken } from "../utility/commonUtility";
import {
  getModulePayload,
  IDeleteModuleRequest,
  IModuleCreate,
  IModuleEdit,
} from "../models/modules/module";

const { MANAGEMENT_SERVICE_URL } = window.env;

export const getModulesForAnApplication = async (
  modulePayload: getModulePayload
) => {
  const { pageSize, pageNo, searchString, applicationId, organizationId } =
    modulePayload;
  let apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/${organizationId}/applications/${applicationId}/modules?page-number=${
    pageNo || 1
  }&page-size=${pageSize || 10}`;
  apiURL = searchString ? `${apiURL}&filter-name=${searchString}` : apiURL;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const createNewModule = async (data: IModuleCreate) => {
  const {
    name,
    description,
    applicationId,
    organizationId,
    serviceId,
    urlPrefix,
    moduleKey,
  } = data;
  const payload = { name, description, serviceId, urlPrefix, moduleKey };
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/${organizationId}/applications/${applicationId}/modules`;
  return postData<any>(createRequestObject(apiURL), payload, getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateModule = async (data: IModuleEdit) => {
  const {
    name,
    description,
    applicationId,
    organizationId,
    serviceId,
    urlPrefix,
    id,
  } = data;
  const payload = { name, description, serviceId, urlPrefix };
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/${organizationId}/applications/${applicationId}/modules/${id}`;
  return putData<any>(createRequestObject(apiURL), payload, getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteModule = async (data: IDeleteModuleRequest) => {
  const { organizationId, applicationId, id } = data;
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/${organizationId}/applications/${applicationId}/modules/${id}`;
  return deleteData(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};
